import type { CSSProperties, ReactElement, ReactNode } from "react";
import { palette, radius, space, type RadiusKey, type SpaceKey } from "@ux/tokens";

export type SurfaceTone = "default" | "raised" | "inset";

export interface SurfaceProps {
    readonly tone?: SurfaceTone;
    readonly padding?: SpaceKey;
    readonly radius?: RadiusKey;
    readonly bordered?: boolean;
    readonly grow?: boolean;
    readonly style?: CSSProperties;
    readonly children?: ReactNode;
}

export function Surface({
    tone = "default",
    padding = 5,
    radius: radiusKey = "lg",
    bordered = true,
    grow = false,
    style,
    children,
}: SurfaceProps): ReactElement {
    const composed: CSSProperties = {
        background: resolveBackground(tone),
        border: bordered ? `1px solid ${palette.border}` : undefined,
        borderRadius: radius[radiusKey],
        padding: space[padding],
        flex: grow ? 1 : undefined,
        minHeight: 0,
        ...style,
    };
    return <div style={composed}>{children}</div>;
}

function resolveBackground(tone: SurfaceTone): string {
    switch (tone) {
        case "default":
            return palette.surface;
        case "raised":
            return palette.surfaceRaised;
        case "inset":
            return palette.surfaceInset;
    }
}
